import React from 'react'
import {useParams} from 'react-router-dom'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageLoader from '../../components/page-loader'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import Optimizely from '../../components/optimizely'
import {MAX_CACHE_AGE_CMS, STALE_WHILE_REVALIDATE_M} from '../../constants'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'
import {hasOptimizelyContent} from '../../utils/optimizely-content'
import ContentFallback from '../../components/optimizely/utils/contentFallback'

const ContentPage = () => {
    const {res} = useServerContext()
    const {pageName} = useParams()

    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE_CMS}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_M}`
        )
    }

    // Remove .html from the page name to get the content key
    const contentKey = pageName?.replace('.html', '') || ''

    // Request content from Optimizely based on the page name
    const {data: optimizelyData, isLoading: isOptimizelyLoading} = useOptimizelyPage(contentKey)
    if (isOptimizelyLoading) {
        return (
            <Box data-testid="content-page">
                <PageLoader />
            </Box>
        )
    }

    // Check if CMS content exists - if not, show 404
    const pageContent = optimizelyData?.page || optimizelyData
    const hasContent = hasOptimizelyContent(pageContent)

    // No authored content for this (brand, locale, key): dev → diagnostic banner,
    // prod → standard error page. Centralized in ContentFallback.
    if (!hasContent) {
        return (
            <Box data-testid="content-page">
                <ContentFallback contentKey={contentKey} />
            </Box>
        )
    }

    // SEO is now handled by the Optimizely component using CMS page data
    // (MetaTitle, MetaDescription, CanonicalUrl, OpenGraphTags, ExcludeFromSitemap)
    return (
        <Box data-testid="content-page">
            <Optimizely content={pageContent} isLoading={isOptimizelyLoading} />
        </Box>
    )
}

export default ContentPage
